<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="kwsImprint.info.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey mb-4" translate="kwsImprint.info.subtitle"></p>

    <app-please-be-patient></app-please-be-patient>

    <div [formGroup]="form" novalidate>
      <div class="field">
        <fino-input
          formControlName="displayName"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>
      <div class="field">
        <fino-input
          formControlName="imprint"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        [disabled]="formNotTouched"
        (click)="submit()"
        fino-button
        label="kwsImprint.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="kwsImprint.abort"
      ></button>
    </div>
  </div>
</div>
